/**
 * Beginner-friendly risk explanations — SINGLE SOURCE OF TRUTH.
 * Used by TokenIntel and any page displaying risk assessments.
 */

export interface RiskExplanation {
  label: string;
  shortExplain: string;
  advice: string;
  cssClass: string;
}

export const RISK_EXPLANATIONS: Record<string, RiskExplanation> = {
  GREEN: {
    label: 'Low Risk Indicators',
    shortExplain: 'No significant warning signs detected across our data sources.',
    advice: 'This token passed our automated checks. Always do your own research.',
    cssClass: 'risk-safe',
  },
  YELLOW: {
    label: 'Be Careful',
    shortExplain: 'Some warning signs detected. Review the details below.',
    advice: 'We found some concerns. Check the specific findings before proceeding.',
    cssClass: 'risk-caution',
  },
  RED: {
    label: 'High Risk Indicators',
    shortExplain: 'Multiple serious warning signs detected.',
    advice: 'Our analysis found serious red flags. Proceed with extreme caution.',
    cssClass: 'risk-danger',
  },
  UNKNOWN: {
    label: 'Not Enough Data',
    shortExplain: 'We could not gather enough data to make a reliable assessment.',
    advice: 'Limited data means higher uncertainty. Be extra careful.',
    cssClass: 'risk-unknown',
  },
};

export function getBeginnerRiskLabel(riskLevel: string | undefined | null): RiskExplanation {
  return RISK_EXPLANATIONS[riskLevel ?? ''] ?? RISK_EXPLANATIONS.UNKNOWN;
}

/** Generic fallback when a field value is null/undefined. Never show "N/A". */
export const FIELD_UNAVAILABLE = 'Not enough public data yet';
